module.exports = __webpack_public_path__ + "static/pp22devices-1d2860828be8ea1d33792577c3258f20.png";